import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/courses-bulk-update-action-types';

import type {List} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type CoursesBulkUpdateStore = {
    ownerUsers: List<unknown>;
};

const initialState = (): CoursesBulkUpdateStore => {
    return {
        ownerUsers: Immutable.List(),
    };
};

const actionsMap: ActionsMap<CoursesBulkUpdateStore> = {
    [actionTypes.GET_OWNER_USERS_SUCCESS]: (state, action) => {
        return {
            ownerUsers: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CoursesBulkUpdateStore>(initialState(), actionsMap);
